import { baseConfig } from "./configs/base-config";
import { eurojackpotConfig } from "./configs/eurojackpot-config";
import { euromilionyConfig } from "./configs/euromiliony-config";
import { extraRentaConfig } from "./configs/extra-renta-config";
import { kamenyConfig } from "./configs/kameny-config";
import { kasickaConfig } from "./configs/kasicka-config";
import { kenoConfig } from "./configs/keno-config";
import { miniRentaConfig } from "./configs/mini-renta-config";
import { rychla6Config } from "./configs/rychla-6-config";
import { sportkaConfig } from "./configs/sportka-config";
import { stastneDatumConfig } from "./configs/stastne-datum-config";
import { stastnych10Config } from "./configs/stastnych-10-config";
import { LotteryConfigModel } from "./models/lottery-configuration-model";
import { Lottery } from "../../models/lottery";

export const getLotteryConfig = (lottery: Lottery, isForKasa?: boolean): LotteryConfigModel => {
    let lotteryConfig = null;
    switch (lottery) {
        case Lottery.euromiliony:
            lotteryConfig = euromilionyConfig;
            break;
        case Lottery.eurojackpot:
            lotteryConfig = eurojackpotConfig;
            break;
        case Lottery.keno:
            lotteryConfig = kenoConfig;
            break;
        case Lottery.kameny:
            lotteryConfig = kamenyConfig;
            break;
        case Lottery.rychla6:
            lotteryConfig = rychla6Config;
            break;
        case Lottery.sportka:
            lotteryConfig = sportkaConfig;
            break;
        case Lottery.stastnych10:
            lotteryConfig = stastnych10Config;
            break;
        case Lottery.kasicka:
            lotteryConfig = kasickaConfig;
            break;
        case Lottery.extraRenta:
            lotteryConfig = extraRentaConfig;
            break;
        case Lottery.miniRenta:
            lotteryConfig = miniRentaConfig;
            break;
        case Lottery.stastneDatum:
            lotteryConfig = stastneDatumConfig;
            break;
        default:
    }

    if (isForKasa) {
        if (lottery == Lottery.sportkaMh) {
            lotteryConfig = { ...sportkaConfig };
            lotteryConfig.multidrawDurationOptions = [];
            lotteryConfig.maxDuration = null;
        }

        if (lottery == Lottery.extraRentaMh) {
            lotteryConfig = { ...extraRentaConfig };
            lotteryConfig.multidrawDurationOptions = [];
            lotteryConfig.maxDuration = null;
        }
    }

    return Object.assign({ ...baseConfig }, lotteryConfig);
};
